import React, { FC } from 'react';

import DateField from '../../../date-field';

interface GuideSelectFilterProps {
  name: string;
  label: string;
  onChange(value: string): void;
}

const DateTimeSelectFilter: FC<GuideSelectFilterProps> = (props) => {
  const { label, onChange } = props;

  return (
    <>
      <DateField
        id="filter"
        label={label}
        onChange={(value) => {
          onChange(value);
        }}
      />
    </>
  );
};

export default DateTimeSelectFilter;
